// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
// 引入icon
import './assets/icon/iconfont.css'
// 
import './utils/rem'

// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
// 引入amfe-flexible
import 'amfe-flexible'

import axios from 'axios';
Vue.prototype.$axios = axios;
// axios.defaults.baseURL = process.env.API_HOST;
// 添加响应拦截器
// axios.interceptors.response.use(function (response) {
//     // 对响应数据做点什么
// 	console.log('响应数据成功触发')//示例代码
//     // 对响应数据做点什么
// 		if(response.status === 200){ //成功状态码200
//             if( response.data.code == -2){
//                 localStorage.removeItem("userInfo")
//                 router.replace({
//                     path:'/login'
//                 })
//             } 
//             return response;    //返回响应的数据
// 		}
//   }, function (error) {
//     // 对响应错误做点什么
//     return Promise.reject(error);
//   });
// 定义响应拦截器 -->token值无效时,清空token,并强制跳转登录页
axios.interceptors.response.use(function (response) {
    // 响应状态码为 2xx 时触发成功的回调，形参中的 response 是“成功的结果”
    if( response.data.code == -2){
        localStorage.removeItem("userInfo")
        router.push('/')
    }
    return response
  }, function (error) {
    // console.log(error)
    // 响应状态码不是 2xx 时触发失败的回调，形参中的 error 是“失败的结果”
    if (error.response.status === 401) {
      // 无效的 token
      // 把 Vuex 中的 token 重置为空，并跳转到登录页面
      // 1.清空token
      
      // 2.跳转登录页
    //   router.push('/login')
    }
    return Promise.reject(error)
  })
  


Vue.config.productionTip = false;

// 使用element UI
Vue.use(ElementUI);
// 过滤器
import * as custom from './utils/util'

Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})

// 路由拦截器
router.beforeEach((to, from, next) => {
    if (to.matched.length != 0) {
        if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
            if (Boolean(localStorage.getItem("userInfo"))) { // 通过vuex state获取当前的user是否存在
                next();
            } else {
                next({
                    path: '/login',
                    query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                })
            }
        } else {
            if (Boolean(localStorage.getItem("userInfo"))) { // 判断是否登录
                if (to.path != "/" && to.path != "/login") { //判断是否要跳到登录界面
                    next();
                } else {
                    /**
                     * 防刷新，如果登录，修改路由跳转到登录页面，修改路由为登录后的首页 
                     */
                    next({
                        path: '/reportList'
                    })
                }
            } else {
                next();
            }
        }
    } else {
        next({
            path: '/login',
            query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
    }
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store, //使用store vuex状态管理
    components: { App },
    template: '<App/>',
    data: {
        // 空的实例放到根组件下，所有的子组件都能调用
        Bus: new Vue()
    }

})


// WEBPACK FOOTER //
// ./src/main.js